module.exports = __webpack_public_path__ + "static/remember_the_milk_1-afbabb7865c8cc2a821a644075a945ff.png";